import { Button } from '@/components/Button';
import stop from '/icons/StopCircle.svg';
import { Modal, ModalBody, ModalContent, ModalFooter } from '@nextui-org/react';
import { useSimulationStore } from '@/store/useSimulationStore';
import { useLocation } from 'react-router';

const GoBackModal = ({ isOpen, onOpenChange, onOpenChangeClose }: any) => {
  const resetStore = useSimulationStore(state => state.resetStore);
  const formData = useSimulationStore(state => state.formData);
  const location = useLocation();
  const isCoachingRoute = location.pathname.includes('coaching');
  const isDonorSimulation = !isCoachingRoute && formData?.practiceType !== 'Coaching';

  const onClickYes = () => {
    resetStore();
    onOpenChange(false);
  };

  return (
    <Modal
      backdrop="opaque"
      isOpen={isOpen}
      onOpenChange={onOpenChangeClose}
      size={'xl'}
      classNames={{
        backdrop: 'bg-gradient-to-t from-zinc-900/50 backdrop-opacity-20 backdrop-blur-sm',
        wrapper: 'custom-modal'
      }}
    >
      <ModalContent>
        <ModalBody className="text-center justify-center items-start pt-10 gap-0">
          <img src={stop} alt="User" width={120} height={120} className="m-auto" />
          <h3 className="text-xl text-darkBlue font-bold mt-2 px-0 lg:px-20">
            {isDonorSimulation
              ? 'Are you sure you want to stop this practice session?'
              : "Are you sure you don't want to talk to Tivy right now?"}
          </h3>
        </ModalBody>
        <ModalFooter className="justify-center gap-3 flex items-start pb-8 flex-wrap">
          <Button label="Yes" onClick={onClickYes} className="py-3" />
          <Button label="No" variant="outline" onClick={() => onOpenChangeClose(false)} className="py-3" />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default GoBackModal;
